export const languageList = {
  AR: {
    displayName: 'العربية',
    language: 'Arabic',
  },
  BE: {
    displayName: 'Беларуская',
    language: 'Belarusian',
  },
  BG: {
    displayName: 'български',
    language: 'Bulgarian',
  },
  BS: {
    displayName: 'Bosanski',
    language: 'Bosnian',
  },
  CA: {
    displayName: 'Català',
    language: 'Catalan',
  },
  CS: {
    displayName: 'Čeština',
    language: 'Czech',
  },
  DA: {
    displayName: 'Dansk',
    language: 'Danish',
  },
  DE: {
    displayName: 'Deutsch',
    language: 'German',
  },
  EL: {
    displayName: 'Ελληνικά',
    language: 'Greek',
  },
  EN: {
    displayName: 'English',
    language: 'English',
  },
  ES: {
    displayName: 'Español',
    language: 'Spanish',
  },
  ET: {
    displayName: 'Eesti',
    language: 'Estonian',
  },
  FI: {
    displayName: 'Suomi',
    language: 'Finnish',
  },
  FR: {
    displayName: 'Français',
    language: 'French',
  },
  HI: {
    displayName: 'हिन्दी',
    language: 'Hindi',
  },
  HR: {
    displayName: 'Hrvatski',
    language: 'Croatian',
  },
  HU: {
    displayName: 'Magyar',
    language: 'Hungarian',
  },
  ID: {
    displayName: 'Bahasa Indonesia',
    language: 'Indonesian',
  },
  IS: {
    displayName: 'Íslenska',
    language: 'Icelandic',
  },
  IT: {
    displayName: 'Italiano',
    language: 'Italian',
  },
  JA: {
    displayName: '日本語',
    language: 'Japanese',
  },
  KO: {
    displayName: '한국어',
    language: 'Korean',
  },
  LT: {
    displayName: 'Lietuvių',
    language: 'Lithuanian',
  },
  LV: {
    displayName: 'Latviešu',
    language: 'Latvian',
  },
  MK: {
    displayName: 'Македонски',
    language: 'Macedonian',
  },
  MN: {
    displayName: 'монгол',
    language: 'Mongolian',
  },
  NB: {
    displayName: 'Norsk (Bokmål)',
    language: 'Norwegian (Bokmal)',
  },
  NL: {
    displayName: 'Nederlands',
    language: 'Dutch',
  },
  NN: {
    displayName: 'Norsk (Nynorsk)',
    language: 'Norwegian Nynorsk',
  },
  NO: {
    displayName: 'Norsk',
    language: 'Norwegian',
  },
  PL: {
    displayName: 'Polski ',
    language: 'Polish',
  },
  PT: {
    displayName: 'Português (Portugal)',
    language: 'Portuguese',
  },
  PT_BR: {
    displayName: 'Português (Brasil)',
    language: 'Brazilian Portuguese',
  },
  RO: {
    displayName: 'Română',
    language: 'Romanian',
  },
  RU: {
    displayName: 'Русский',
    language: 'Russian',
  },
  SK: {
    displayName: 'Slovenčina',
    language: 'Slovak',
  },
  SL: {
    displayName: 'Slovenščina',
    language: 'Slovenian',
  },
  SQ: {
    displayName: 'Shqip',
    language: 'Albanian',
  },
  SR: {
    displayName: 'Српски',
    language: 'Serbian (cyrillic)',
  },
  SR_LATN: {
    displayName: 'Srpski',
    language: 'Serbian (latin)',
  },
  SV: {
    displayName: 'Svenska',
    language: 'Swedish',
  },
  TH: {
    displayName: 'ไทย',
    language: 'Thai',
  },
  TR: {
    displayName: 'Türkçe',
    language: 'Turkish',
  },
  UK: {
    displayName: 'Українська',
    language: 'Ukrainian',
  },
  UR: {
    displayName: 'اردو',
    language: 'Urdu',
  },
  VI: {
    displayName: 'Tiếng Việt',
    language: 'Vietnamese',
  },
  ZH: {
    displayName: '简体中文',
    language: 'Chinese Simplified',
  },
  ZH_HK: {
    displayName: '繁體中文 (香港)',
    language: 'Chinese Traditional (Hong Kong)',
  },
  ZH_TW: {
    displayName: '繁體中文',
    language: 'Chinese Traditional',
  },
};
